
<teleport to="body">
<div class="modal fade show" @click="close_file_preview_modal"></div>
<div class="modal show d-block" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered" @click.stop>
    <div class="modal-content">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h5 class="modal-title d-flex align-items-center">
          <p class="text-white">Previewing File</p>
        </h5>
        <button type="button" class="btn-close modal-close-btn" @click="close_file_preview_modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-0">
        <!-- Loading state -->
        <div v-if="loading" class="d-flex justify-content-center align-items-center h-100">
          <div class="text-center">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2">Loading preview...</p>
          </div>
        </div>

        <!-- Preview content -->
        <div v-else class="h-100">
          <!-- PDF files -->
          <iframe
            v-if="file_type === 'pdf'"
            :src="preview_url"
            width="100%"
            height="600px"
            frameborder="0">
          </iframe>

          <!-- Word documents -->
          <iframe
            v-else-if="['doc', 'docx'].includes(file_type) && office_embed_url"
            :src="office_embed_url"
            width="100%"
            height="600px"
            frameborder="0">
          </iframe>

          <!-- Excel files -->
          <iframe
            v-else-if="['xls', 'xlsx', 'xlsm', 'xlsb'].includes(file_type) && office_embed_url"
            :src="office_embed_url"
            width="100%"
            height="600px"
            frameborder="0">
          </iframe>

          <!-- PowerPoint files -->
          <iframe
            v-else-if="['ppt', 'pptx'].includes(file_type) && office_embed_url"
            :src="office_embed_url"
            width="100%"
            height="600px"
            frameborder="0">
          </iframe>

          <!-- Office files without embeddable public HTTPS URL -->
          <div v-else-if="is_office_file_type()" class="d-flex justify-content-center align-items-center h-100 bg-light">
            <div class="text-center p-4">
              <i class="bi bi-file-earmark-word display-4 text-secondary mb-3"></i>
              <h4>Preview not available</h4>
              <p class="text-muted">{{ preview_error_message }}</p>
              <p class="text-muted mb-3">File: {{ internal_file_name }}</p>
            </div>
          </div>

          <!-- Images -->
          <img
            v-else-if="['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(file_type)"
            :src="preview_url"
            :alt="file_name"
            class="img-fluid w-100"
            style="object-fit: contain; max-height: 600px;">

          <!-- Videos -->
          <video
            v-else-if="['mp4', 'webm', 'avi', 'mov', 'wmv'].includes(file_type)"
            :src="preview_url"
            controls
            class="w-100"
            style="max-height: 600px;">
            Your browser does not support the video tag.
          </video>

          <!-- Audio -->
          <div v-else-if="['mp3', 'wav', 'ogg'].includes(file_type)" class="d-flex justify-content-center align-items-center h-100 bg-dark">
            <audio :src="preview_url" controls class="w-75"></audio>
          </div>

          <!-- Text files -->
          <iframe
            v-else-if="['txt', 'csv', 'json', 'xml'].includes(file_type)"
            :src="preview_url"
            width="100%"
            height="600px"
            frameborder="0">
          </iframe>

          <!-- Unsupported files -->
          <div v-else class="d-flex justify-content-center align-items-center h-100 bg-light">
            <div class="text-center p-4">
              <i class="fas fa-file-excel display-4 text-secondary mb-3"></i>
              <h4>Preview not available</h4>
              <p class="text-muted">This file type cannot be previewed in the browser.</p>
              <p class="text-muted mb-3">File: {{ internal_file_name || file_name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer bg-light">
        <a v-if="preview_url" :href="preview_url" :download="file_name" class="btn btn-primary">
          Download
        </a>
      </div>
    </div>
  </div>
</div>
</teleport>